// Paste your Google Calendar appointment-schedule link here when ready
// (e.g. https://calendar.app.google/xxxx). Until then, every
// "Book a discovery call" button opens the inquiry form instead.
export const BOOKING_URL = "https://calendar.app.google/ZgcC5pufXsqTwBa88";
export const CONTACT_EMAIL = "info@oasisbusiness.in";
export const SITE_URL = "https://oasisbusiness.in";

// Your Google Business Profile review link (GBP dashboard → "Ask for reviews" → copy the link).
// Rendered as a branded QR card in the /admin dashboard, ready to send to clients.
export const GOOGLE_REVIEW_URL = "https://share.google/iX3TBQcsgATiuqF6e";
export const CONTACT_PHONE = "+917796298181";
export const CONTACT_PHONE_DISPLAY = "+91 77962 98181";

// Your WhatsApp Business number with country code, digits only (e.g. "919876543210").
// Until set, the chat widget routes people to the inquiry form instead.
export const WHATSAPP_NUMBER = "917796298181";
export const WHATSAPP_DEFAULT_MSG = "Hi Oasis Business Solutions! I'd like to talk about a project.";
